import { useEffect, useRef } from 'react';
import type { Track } from 'livekit-client';

export function MediaTile({ track, label, muted = false }: { track: Track; label: string; muted?: boolean }) {
  const container = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = track.attach();
    element.autoplay = true;
    if (element instanceof HTMLVideoElement) element.playsInline = true;
    if (element instanceof HTMLMediaElement) element.muted = muted;
    container.current?.prepend(element);
    return () => {
      track.detach(element);
      element.remove();
    };
  }, [muted, track]);
  return <div className="media-tile" ref={container}><span>{label}</span></div>;
}

